import { useState, useEffect } from 'react'
import { Pagination } from 'react-bootstrap'
import NewCard from '@/components/news-card'
import Styles from './style.module.scss'
import { get, post } from '@/utils/fetch'
import useLang from '@/utils/hooks/use-lang'
import { news as newList } from '@/pages/about-us/news-data'
import { Flex, Image } from 'antd'

const PageSize = 6

export function NewsItem(props) {
  const { item } = props
  return (
    <div className={Styles.newsItem}>
      <Image src={item.image} preview={false} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
      <div className={Styles.content}>
        <div className={Styles.title} onClick={() => window.open(item.link)}>
          {item.title}
        </div>
        <div className={Styles.date}>{item.date}</div>
      </div>
    </div>
  )
}

export default function Index({ little = 3 }) {
  const [list, setList] = useState(newList)
  const [total, setTotal] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [lang] = useLang()

  let active = 2
  let items = []
  for (let number = 1; number <= 15; number++) {
    items.push(
      <Pagination.Item key={number} active={number === active}>
        {number}
      </Pagination.Item>
    )
  }

  const handleRequest = pageIndex => {
    get(`/api/news/${lang}?page=${pageIndex}&pagesize=${little || PageSize}`)().then(res => {
      if (res?.code === 0) {
        const l =
          res?.data?.reduce((acc, cur, index) => {
            const groupIndex = Math.floor(index / 3)
            if (!acc[groupIndex]) {
              acc[groupIndex] = []
            }
            acc[groupIndex].push(cur)
            return acc
          }, []) || []

        setList(l)
        setTotal(+res?.count || 0)
      }
    })
  }

  useEffect(() => {
    // handleRequest(currentPage)
  }, [currentPage, lang])

  return (
    <Flex wrap className={Styles.list}>
      {list.map(i => (
        <NewsItem key={i.id} item={i} />
      ))}
    </Flex>
  )
}
